<template>
  <div>
    <!--Navigation.vue - oranisms components -->
    <navigation v-if="isNavigationShow" :userProfile="userProfile" />
    <!--Sidebar.vue - oranisms components -->
    <side-bar />
    <v-main>
      <!--VBreadcrumbs - Vuetify-->
      <v-breadcrumbs class="ml-2 mt-5 font-medium">
        <template>
          <!-- VIcon - Vuetify -->
          <v-icon
            class="d-lg-none"
            :class="[isOpen ? 'invisible' : 'mr-3']"
            @click="toggleSidebar(!isOpen)"
          >
            mdi-view-headline
          </v-icon>
          <!--VBreadcrumbItem - Vuetify-->
          <v-breadcrumbs-item
            v-for="(item, index) in breadcrumbsList"
            :key="index"
            :href="item.path ? item.path : '/'"
          >
            <span v-if="item.name" class="hover:font-bold text-black">
              <span class="mr-1">/</span> {{ item.name }}
            </span>
            <span v-else class="hover:font-bold text-black"> Trang chủ </span>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <loading :is-showed="requestPending" />
      <router-view />
      <app-modal />
      <app-dialog />
      <vue-internet-checker @status="status" @event="event" />
    </v-main>
  </div>
</template>

<script>
import { EVENT } from "~/utils/constants";
import vueInternetChecker from "vue-internet-checker";
import { mapMutations } from "vuex";

export default {
  components: {
    SideBar: () => import("~/components/organisms/SideBar"),
    Navigation: () => import("~/components/organisms/Navigation"),
    Loading: () => import("~/components/molecules/Loading"),
    AppDialog: () => import("~/components/organisms/dialog/Index"),
    vueInternetChecker,
  },

  data() {
    return {
      isShowedLoading: false,
      requestPending: 0,
      userProfile: null,
      isNavigationShow: false,
      onLine: null,
    };
  },

  async created() {
    this.$eventBus.$on(EVENT.LOADING, this.handleLoader);
    await this.$services.commonService.getMasterData();
    if (this.userProfile == null) {
      try {
        this.isLoading = true;
        const data = await this.$services.commonService.getUserProfile();
        if (
          data &&
          Object.keys(data).length !== 0 &&
          Object.getPrototypeOf(data) === Object.prototype
        ) {
          this.userProfile = data;
          this.$store.commit("setData", { userProfile: this.userProfile });
          this.isNavigationShow = true;
        }
      } catch (err) {
        throw err;
      } finally {
        this.isLoading = false;
        try {
          await Promise.all([this.$store.dispatch("initMasterData")]);
        } catch (err) {
          throw err;
        }
      }
    }
  },

  computed: {
    isOpen: {
      get() {
        return this.$store.state.sidebar.isOpen;
      },
      set(val) {
        this.$store.commit("sidebar/TOGGLE_SIDEBAR", val);
      },
    },
    breadcrumbsList() {
      let pathArray = this.$route.path.split("/");
      let breadcrumbs = [];
      for (let i = 0; i < pathArray.length; i++) {
        if (this.$route.matched[i]) {
          breadcrumbs.push({
            path: this.$route.matched[i].path,
            name: this.$route.matched[i].meta.breadcrumbs,
          });
        }
      }
      return breadcrumbs;
    },
  },

  beforeDestroy() {
    this.$eventBus.$off(EVENT.LOADING, this.handleLoader);
  },

  methods: {
    ...mapMutations("sidebar", {
      toggleSidebar: "TOGGLE_SIDEBAR",
    }),
    status(ele) {
      console.log(ele);
      this.onLine = ele;
    },
    event(ele) {
      if (ele.type == "offline") {
        this.$toasted
          .error("Mất kết nối internet. Vui lòng kiểm tra kết nối mạng!", {
            position: "top-right",
          })
          .goAway(5000);
      }
    },
    handleLoader(value) {
      if (value) {
        this.requestPending += 1;
      } else {
        this.requestPending -= 1;
      }
      if (this.requestPending <= 0) {
        this.requestPending = 0;
      }
    },
  },
};
</script>
